
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.767 5.458H7.45a.579.579 0 01-.579-.578v-.29a.59.59 0 00-.59-.59H3.18A1.18 1.18 0 002 5.18v9.928l1.514-7.365a.579.579 0 01.567-.462h14.866v-.643a1.18 1.18 0 00-1.18-1.18z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M20.82 8.438H4.553L2.276 19.515a.586.586 0 00.574.704h16.928a1.18 1.18 0 001.173-1.05l1.042-9.421a1.18 1.18 0 00-1.173-1.31z","fill":"#282E3E"}})])
          )
        }
      }
    